import React from 'react';
import { Bar, CartesianGrid, Cell, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { TrendPoint } from '../../hooks/useCompanyOverview';
import { formatCurrency } from '../../utils/commission';
interface CompanyTrendChartProps {
  data: TrendPoint[];
}
export function CompanyTrendChart({
  data
}: CompanyTrendChartProps) {
  return <section aria-labelledby="trend-heading" className="h-full rounded-xl border border-slate-200 bg-white p-6 shadow-card" data-id="element-35" data-mp="2v1yrnaythrvs">
      <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-36" data-mp="2q3nhez4m1fd1">
        <div data-id="element-37" data-mp="33u0n0uu14hz7">
          <h2 id="trend-heading" className="text-base font-bold text-slate-900" data-id="element-38" data-mp="33uslcdf0gtt6">
            Commissions &amp; funded units
          </h2>
          <p className="mt-0.5 text-sm text-slate-500" data-id="element-39" data-mp="2z1zhdrrd9pi5">Company totals by pay period</p>
        </div>
        <div className="flex items-center gap-4 text-xs font-semibold text-slate-600" data-id="element-40" data-mp="2bcereowsprzd">
          <span className="flex items-center gap-1.5" data-id="element-41" data-mp="27bl705ikavb8">
            <span aria-hidden="true" className="h-2.5 w-2.5 rounded-sm bg-brand-600" data-id="element-42" data-mp="3njficjvufuex" />
            Commissions
          </span>
          <span className="flex items-center gap-1.5" data-id="element-43" data-mp="3sh7bfh885mkp">
            <span aria-hidden="true" className="h-0.5 w-4 rounded-full bg-gold-500" data-id="element-44" data-mp="3sfwarqa2suxt" />
            Funded units
          </span>
        </div>
      </div>
      <div className="mt-4 h-64" data-id="element-45" data-mp="61ctnltpv1nn">
        <ResponsiveContainer width="100%" height="100%" data-id="element-46" data-mp="64qu2oitl0sg">
          <ComposedChart data={data} margin={{
          top: 8,
          right: 4,
          left: 4,
          bottom: 0
        }} data-id="element-47" data-mp="34ld0cp1pqxqm">
            <CartesianGrid vertical={false} stroke="#e2e8f0" data-id="element-48" data-mp="39ilb44kj7zhu" />
            <XAxis dataKey="label" tickLine={false} axisLine={false} tick={{
            fill: '#64748b',
            fontSize: 12
          }} data-id="element-49" data-mp="3eihdjzdkziva" />
            <YAxis yAxisId="commission" tickLine={false} axisLine={false} width={56} tick={{
            fill: '#64748b',
            fontSize: 12
          }} tickFormatter={(value: number) => `$${Math.round(value / 1000)}k`} data-id="element-50" data-mp="3jhatrzk95nz5" />
            <YAxis yAxisId="units" orientation="right" tickLine={false} axisLine={false} width={32} tick={{
            fill: '#64748b',
            fontSize: 12
          }} data-id="element-51" data-mp="2uuhpkz7f0t00" />
            <Tooltip cursor={{
            fill: '#f1f5f9'
          }} content={<TrendTooltip data-id="element-53" data-mp="33strvyhn9f8a" />} data-id="element-52" data-mp="33u4vnyb3amze" />
            <Bar yAxisId="commission" dataKey="commission" radius={[6, 6, 0, 0]} maxBarSize={56} data-id="element-54" data-mp="2zt1gzf4s2wzr">
              {data.map(point => <Cell key={point.periodLabel} fill={point.isSelected ? '#1a3fd0' : '#bfd6fe'} data-id="element-55" data-mp="2c4i56pmis22x" />)}
            </Bar>
            <Line yAxisId="units" dataKey="fundedUnits" type="monotone" stroke="#f97d16" strokeWidth={2.5} dot={{
            r: 4,
            fill: '#f97d16',
            strokeWidth: 0
          }} data-id="element-56" data-mp="2732mh47te7np" />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </section>;
}
interface TrendTooltipProps {
  active?: boolean;
  payload?: {
    payload: TrendPoint;
  }[];
}
function TrendTooltip({
  active,
  payload
}: TrendTooltipProps) {
  if (!active || !payload || payload.length === 0) return null;
  const point = payload[0].payload;
  return <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs shadow-lg" data-id="element-57" data-mp="14cb7l4mdmxp7">
      <p className="font-bold text-slate-900" data-id="element-58" data-mp="14agl3lvgixj0">{point.periodLabel}</p>
      <p className="mt-1 text-slate-600" data-id="element-59" data-mp="19bw3t7a5wry8">
        Commissions <span className="font-semibold tabular-nums text-slate-900" data-id="element-60" data-mp="1x0ffzxwc1ovl">{formatCurrency(point.commission)}</span>
      </p>
      <p className="text-slate-600" data-id="element-61" data-mp="21z0ffv3rg4iz">
        Funded units <span className="font-semibold tabular-nums text-slate-900" data-id="element-62" data-mp="21xpb9u6ekurc">{point.fundedUnits}</span>
      </p>
    </div>;
}